/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import vanBangChoDuyetProcessor from '../../../processor/vanBangChoDuyetProcessor'
import { dateToDDMMYY } from '../../../utils/date'
import PhanHoiPopup from '../PhanHoiPopup'
import ListVanBangWithView from '../ListVanBangWithView'

const processor = vanBangChoDuyetProcessor

export default function ChoDuyet() {
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const [reload, setReload] = useState(false)
  const [selected, setSelected] = useState({})
  const [visible, setVisible] = useState(false)
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)

  const toggle = () => setVisible(!visible)

  const additionColumn = [
    {
      value: 'chinhSuaVanBangs',
      name: 'Thông tin phản hồi',
      render: (data) => {
        return (
          <div>
            {data.phanHois &&
              data.phanHois.map((item) => (
                <p>{`[${dateToDDMMYY(new Date(item.createDate))}] ${item.user.fullname}: ${
                  item.noiDung
                }`}</p>
              ))}
          </div>
        )
      },
    },
  ]
  const showMessage = (rs) => {
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setReload(true)
  }
  const duyet = async (data) => {
    const rs = await vanBangChoDuyetProcessor.duyet([{ ...data, phanHois: undefined }], khoaThiId)
    showMessage(rs)
  }
  const duyetAll = async () => {
    const rs = await processor.duyetAll(khoaThiId)
    showMessage(rs)
  }
  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-check',
        className: 'p-button-rounded p-button-success mr-2',
        disabled: data.duocPhanHoi,
        tooltip: 'Duyệt',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          confirm({
            action: () => duyet(data),
            body: `Bạn có muốn duyệt văn bằng này?`,
          })
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-comment',
        className: 'p-button-rounded p-button-warning mr-2',
        tooltip: 'Phản hồi',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          toggle()
          setSelected(data)
        },
      }
    },
  ]
  return (
    <>
      <PhanHoiPopup
        id={selected.id}
        load={() => setReload(true)}
        visible={visible}
        toggle={toggle}
      />
      <ListVanBangWithView
        moduleTitle="Danh sách văn bằng chờ duyệt"
        getMethod={processor.getByKhoaThi}
        reload={reload}
        setReload={setReload}
        additionColumn={additionColumn}
        buttons={buttons}
        headerLeft={
          <div>
            <Button
              icon="pi pi-check"
              className="p-button-success ml-2"
              onClick={() => {
                confirm({
                  action: () => duyetAll(),
                  body: `Bạn có muốn duyệt tất cả văn bằng?`,
                })
              }}
              label="Duyệt tất cả"
            />
          </div>
        }
      />
    </>
  )
}
